import {AppraisalsPage} from 'modules/Appraisals';

export default AppraisalsPage;